export default {
    CONSENT_TYPE_MARKETING: 'marketing',
    CONSENT_TYPE_NECESSARY: 'necessary',
    CONSENT_TYPE_PREFERENCES: 'preferences',
    CONSENT_TYPE_STATISTICS: 'statistics',
};
